module.exports = __webpack_public_path__ + "media/images/weather/21_night-4d89cee091304d6e8aad56923746f24a.png";